import React, {PureComponent} from 'react';
import Template from "../components/Template";
import Navbar from "../components/Navbar";
import Modal from "../components/helpers/Modal";
import SwalToast from "../components/helpers/SwalToast";
import Config from "../components/axios/Config";
import $ from "jquery";
import axios from "axios";
import Cookie from "js-cookie";
import IsEmpty from "../components/helpers/IsEmpty";

class ChangePassword extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isEditMode: false,
            action_button_disabled: false,
            old_password: '',
            new_password: '',
            confirm_password: '',
            error_message: {
                old_password: '',
                new_password: '',
                confirm_password: '',
            },
        };
        this.check = this.check.bind(this);
        this.save = this.save.bind(this);
    }

    check() {
        this.setState({
            action_button_disabled: true
        }, () => {
            let temp_error_message = {...this.state.error_message};
            let old_password = this.state.old_password;
            let new_password = this.state.new_password;
            let confirm_password = this.state.confirm_password;
            if (old_password === '') {
                temp_error_message.old_password = 'The old password field is required.';
                temp_error_message.new_password = '';
                temp_error_message.confirm_password = '';
                this.setState({
                    error_message: {...temp_error_message},
                    action_button_disabled: false
                });
            } else if (new_password === '') {
                temp_error_message.old_password = '';
                temp_error_message.new_password = 'The new password field is required.';
                temp_error_message.confirm_password = '';
                this.setState({
                    error_message: {...temp_error_message},
                    action_button_disabled: false
                });
            } else {
                if (new_password.length < 8) {
                    temp_error_message.old_password = '';
                    temp_error_message.new_password = 'Minimum 8 characters';
                    temp_error_message.confirm_password = '';
                    this.setState({
                        error_message: {...temp_error_message},
                        action_button_disabled: false
                    });
                } else if (confirm_password === '') {
                    temp_error_message.old_password = '';
                    temp_error_message.new_password = '';
                    temp_error_message.confirm_password = 'The confirm password field is required.';
                    this.setState({
                        error_message: {...temp_error_message},
                        action_button_disabled: false
                    });
                } else {
                    if (new_password === confirm_password) {
                        this.setState({
                            error_message: {
                                old_password: '',
                                new_password: '',
                                confirm_password: '',
                            },
                            action_button_disabled: false
                        });
                        $('#change-password-confirmation').modal('show');
                    } else {
                        temp_error_message.old_password = '';
                        temp_error_message.new_password = '';
                        temp_error_message.confirm_password = 'Password does not match!';
                        this.setState({
                            error_message: {...temp_error_message},
                            action_button_disabled: false
                        });
                    }
                }
            }
        });
    }

    save() {
        this.setState({
            action_button_disabled: true
        }, () => {
            $('#change-password-confirmation').modal('hide');
            let temp_error_message = {...this.state.error_message};
            let old_password = this.state.old_password;
            let new_password = this.state.new_password;
            let confirm_password = this.state.confirm_password;
            if (old_password === '') {
                temp_error_message.old_password = 'The old password field is required.';
                temp_error_message.new_password = '';
                temp_error_message.confirm_password = '';
                this.setState({
                    error_message: {...temp_error_message},
                    action_button_disabled: false
                });
            } else if (new_password === '') {
                temp_error_message.old_password = '';
                temp_error_message.new_password = 'The new password field is required.';
                temp_error_message.confirm_password = '';
                this.setState({
                    error_message: {...temp_error_message},
                    action_button_disabled: false
                });
            } else {
                if (new_password.length < 8) {
                    temp_error_message.old_password = '';
                    temp_error_message.new_password = 'Minimum 8 characters';
                    temp_error_message.confirm_password = '';
                    this.setState({
                        error_message: {...temp_error_message},
                        action_button_disabled: false
                    });
                } else if (confirm_password === '') {
                    temp_error_message.old_password = '';
                    temp_error_message.new_password = '';
                    temp_error_message.confirm_password = 'The confirm password field is required.';
                    this.setState({
                        error_message: {...temp_error_message},
                        action_button_disabled: false
                    });
                } else {
                    if (new_password === confirm_password) {
                        axios.post(`${process.env.REACT_APP_BASE_API_URL}auth/changePassword`, {
                            old_password: old_password,
                            new_password: new_password,
                            confirm_password: confirm_password,
                        }, Config({
                            Authorization: `Bearer ${Cookie.get('token')}`
                        })).then(response => {
                            this.setState({
                                isEditMode: false,
                                action_button_disabled: false,
                                old_password: '',
                                new_password: '',
                                confirm_password: '',
                            }, () => {
                                SwalToast.fire({icon: 'success', title: 'Successfully changed!'});
                            });
                        }).catch(error => {
                            this.setState({
                                action_button_disabled: false,
                                old_password: '',
                                new_password: '',
                                confirm_password: '',
                            }, () => {
                                SwalToast.fire({
                                    icon: 'error',
                                    title: error.response ? error.response.data.message : 'Whoops, something went wrong!'
                                });
                            });
                        });
                    } else {
                        temp_error_message.old_password = '';
                        temp_error_message.new_password = '';
                        temp_error_message.confirm_password = 'Password does not match!';
                        this.setState({
                            error_message: {...temp_error_message},
                            action_button_disabled: false
                        });
                    }
                }
            }
        });
    }

    render() {
        return (
            <Template>
                <Navbar>
                    <h4 className="m-0 color-374650 font-weight-bold">Change Password</h4>
                </Navbar>
                <div className="p-3">
                    <Modal modalId={"change-password-confirmation"} title={"Are you sure?"}>
                        <div className="text-center mt-2">
                            <i className="fas fa-question color-0F74BD fa-9x"></i>
                        </div>
                        <div className="mt-4 row no-gutters">
                            <div className="col-6 pr-2">
                                <button className="btn btn-block color-95A4AF border-95A4AF hover-95A4AF" data-dismiss="modal">Cancel</button>
                            </div>
                            <div className="col-6 pl-2">
                                <button
                                    onClick={this.save}
                                    className="btn btn-block text-white bgc-0F74BD shadow-graph"
                                >Okay</button>
                            </div>
                        </div>
                    </Modal>
                    <div className="">
                        <p className="m-0 color-22262A font-weight-bold">Account Security</p>
                        <div className="mt-3 d-flex align-items-center">
                            <p className="m-0 color-22262A font-weight-semi-bold">Password:</p>
                            <p className="mb-0 ml-5 color-22262A font-weight-semi-bold">************</p>
                            {!this.state.isEditMode &&
                            <a
                                href="javascript:void(0)"
                                className="ml-5 color-2E90E5 small"
                                onClick={event => this.setState({
                                    isEditMode: true
                                })}
                            >Change</a>}
                        </div>
                        {this.state.isEditMode &&
                        <div className="row mt-3">
                            <div className="col-6">
                                <div className="form-group">
                                    <label htmlFor="old-password-field" className="color-374650">Old Password</label>
                                    <input
                                        autoComplete={"new-password"}
                                        type="password"
                                        className="form-control"
                                        id="old-password-field"
                                        placeholder="Old Password"
                                        value={this.state.old_password}
                                        onChange={event => this.setState({
                                            old_password: event.target.value
                                        })}
                                    />
                                    {this.state.error_message.old_password !== '' &&
                                    <div className="alert alert-danger py-2 mt-2" role="alert">
                                        {this.state.error_message.old_password}
                                    </div>}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="new-password-field" className="color-374650">New Password</label>
                                    <input
                                        autoComplete={"new-password"}
                                        type="password"
                                        className="form-control"
                                        id="new-password-field"
                                        placeholder="New Password"
                                        value={this.state.new_password}
                                        onChange={event => this.setState({
                                            new_password: event.target.value
                                        })}
                                    />
                                    {this.state.error_message.new_password !== '' &&
                                    <div className="alert alert-danger py-2 mt-2" role="alert">
                                        {this.state.error_message.new_password}
                                    </div>}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="confirm-password-field" className="color-374650">Confirm Password</label>
                                    <input
                                        autoComplete={"new-password"}
                                        type="password"
                                        className="form-control"
                                        id="confirm-password-field"
                                        placeholder="Confirm Password"
                                        value={this.state.confirm_password}
                                        onChange={event => this.setState({
                                            confirm_password: event.target.value
                                        })}
                                    />
                                    {this.state.error_message.confirm_password !== '' &&
                                    <div className="alert alert-danger py-2 mt-2" role="alert">
                                        {this.state.error_message.confirm_password}
                                    </div>}
                                </div>
                                <div className="d-flex justify-content-between">
                                    <button
                                        className="btn border-EB2424 shadow-graph color-EB2424 font-weight-bold"
                                        onClick={event => this.setState({
                                            isEditMode: false,
                                            old_password: '',
                                            new_password: '',
                                            confirm_password: '',
                                            error_message: {
                                                old_password: '',
                                                new_password: '',
                                                confirm_password: '',
                                            },
                                        })}
                                    >Cancel</button>
                                    <button
                                        className="btn bgc-374650 shadow-graph text-white font-weight-bold"
                                        disabled={this.state.action_button_disabled}
                                        onClick={this.check}
                                    >Save</button>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
            </Template>
        );
    }
}

export default ChangePassword;